/* this is main mapping for different sections of the app */

export const NAVIGATION_SETTINGS = "_kaboodle_navigation_settings";

export const SECTION = {
  TASKS: "TASKS",
  OPERATIONS: "OPERATIONS",
  INTAKE: "INTAKE",
  SECTION_111_DASHBOARD: "SECTION_111_DASHBOARD",
  SECTION_111_CLAIMS: "SECTION_111_CLAIMS",
  SECTION_111_RRES: "SECTION_111_RRES",
  SECTION_111_REPORTING: "SECTION_111_REPORTING",
  LIENS: "LIENS",
  FUTURE_MEDICAL: "FUTURE_MEDICAL",
  MSA: "Medicare Set-Aside",
  MSA_111: "MSA-111",
  NTMSA: "Non-Threshold MSA",
  PRE_MSA: "Pre-MSA Snapshot",
  AMENDED_REVIEW: "Amended Review",
  AMENDED_REVIEW_SCREENING: "Amended Review Screening",
  LCP: "LCP",
  MCP: "MCP",
  DOCUMENT_MANAGEMENT: "Document Management",
  META_DOCUMENTS: "META_DOCUMENTS",
  SETTINGS: "SETTINGS",
  REFERRAL_SETTINGS: "REFERRAL_SETTINGS",
  CLIENT: "CLIENT",
  CLAIMANT: "CLAIMANT",
  EMPLOYER: "EMPLOYER",
  JOBS: "JOBS",
  FINANCE: "FINANCE",
  REPORTS: "reports",
} as const;
export type SECTION_TYPE = keyof typeof SECTION;

// future medical service types: the "is this a Future Medical service"
// classifier used by the header service pills and the intake form. It says
// nothing about the CMS workflow; that is MSA_TYPES_WITHOUT_CMS_SUBMISSION below.
export const FM_SERVICE_TYPES: readonly string[] = [
  "MSA",
  "MSA-111",
  "NTMSA",
  "PRE-MSA",
  "ARV",
  "ARS",
  "MCP",
  "LCP",
];

// The CMS Submission, Invoice (CMS), CMS Status and F.S.D workflow parts only
// apply to MSA flavors that are actually submitted to CMS. NTMSA, MSA-111 and
// Pre-MSA Snapshot are never submitted, so those views, nav entries and status
// bar segments are dropped for them (mirrors `MSA_TYPES_WITHOUT_CMS_SUBMISSION`
// on the server).
export const MSA_TYPES_WITHOUT_CMS_SUBMISSION: readonly string[] = [
  SECTION.NTMSA,
  SECTION.MSA_111,
  SECTION.PRE_MSA,
];

// route segments / status keys of the CMS workflow parts
export const CMS_SUBMISSION_SECTIONS = [
  "cms-submission",
  "invoice-cms",
  "cms-status",
  "fsd",
] as const;

export const serviceTypeHasCmsSubmission = (
  serviceType: string | null | undefined,
): boolean =>
  !serviceType || !MSA_TYPES_WITHOUT_CMS_SUBMISSION.includes(serviceType);

export const isCmsSubmissionSection = (
  section: string | null | undefined,
): boolean =>
  !!section && (CMS_SUBMISSION_SECTIONS as readonly string[]).includes(section);
